import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { TargetGroup } from '../../models/TargetGroup';
import { RootState } from '../store';

export interface TargetGroupState {
  value: TargetGroup | undefined;
}

const initialState: TargetGroupState = { value: undefined };

export const targetGroupSlice = createSlice({
  name: 'targetGroup',
  initialState,
  reducers: {
    setTargetGroup: (state: TargetGroupState, action: PayloadAction<TargetGroup | undefined>) => {
      state.value = action.payload;
    },
  },
});

export const selectedTargetGroup = (state: RootState) => state.targetGroup.value;

export const { setTargetGroup } = targetGroupSlice.actions;

export default targetGroupSlice.reducer;
